<template>
  <div>
    <h1>Esportazioni</h1>
    <h2 v-if="modelli.length === 0" class="red--text"><br/><br/><br/>Attualmente non sono definite procedure di esportazione dati</h2>
    <v-row class="mt-5" v-if="modelli.length > 0"> 
      <v-col cols="3" v-for="(m, idx) in modelli" :key="idx">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ m.titolo }}</span>
          </v-card-title>
          <v-card-subtitle>
            {{ m.descrizione }}
          </v-card-subtitle>
          <div class="mx-4 text-subtitle-3">Tipo esportazione: {{ m.file.tipo }}</div>
          <div class="mx-4 text-subtitle-3">Destinazione: {{ m.file.destinazione || 'locale' }}</div>
          <!-- <v-divider class="mx-4"></v-divider> -->
          <v-card-text v-if="mostraFiltri(m)">
            <v-row align="center" justify="space-around" dense>
              <v-col>
                <v-menu
                  v-model="menuStart[idx]"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedStartFormatted(idx)"
                      label="Dalla data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details
                      @click:clear="filtro[idx].start = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filtro[idx].start" no-title scrollable @input="menuStart[idx] = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuEnd[idx]"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedEndFormatted(idx)"
                      label="Alla data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details
                      @click:clear="filtro[idx].end = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filtro[idx].end" no-title scrollable @input="menuEnd[idx] = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onEsporta(m.codice, idx, true)">Esporta</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import configurazioni from '@/services/configurazioniService.js'
  import exportService from '@/services/exportService.js'

  export default {
    mixins: [verificaLicenza],
    data: (vm) => ({
      modelli: [],
      startFormatted: [],
      endFormatted: [],
      filtro: [],
      menuStart: [],
      menuEnd: []    
    }),
    watch: {
      'filtro.start' (val) {
        this.startFormatted = this.formatDate(this.filtro.start)
      },
      'filtro.end' (val) {
        this.endFormatted = this.formatDate(this.filtro.end)
      }
    },    
    async mounted() {      
      await this.verificaModuliLocali()
      const modelli = await configurazioni.getConfigurazione('export_dati', 'modelli')
      this.modelli = modelli.generici
      for (let m of this.modelli) {
        const start =  moment().add(_.get(m, 'periodo.giorniStart', 0), 'days').format('YYYY-MM-DD')
        const end = moment().add(_.get(m, 'periodo.giorniEnd', 0), 'days').format('YYYY-MM-DD')
        const filtro = {
          start: start,
          end: end
        }        
        this.filtro.push(filtro)
        this.menuStart.push(false)
        this.menuEnd.push(false)
        this.startFormatted.push(start)
        this.endFormatted.push(end)
      }
    },
    methods: {
      mostraFiltri(modello) {
        return !modello.nascondiFiltri
      },
      computedStartFormatted (idx) {
        return this.formatDate(this.filtro[idx].start)
      },
      computedEndFormatted (idx) {
        return this.formatDate(this.filtro[idx].end)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      async onEsporta(codiceModello, idx, verbose) {
        const modello = this.modelli.find(x => x.codice === codiceModello)
        const filtro = this.filtro[idx]
        if (modello.file.tipo === 'webservice') {
          const result = await exportService.callWebservice(modello, filtro)
          if (verbose && result) {
            alert(result.status)
          }          
          return
        }
        try {
          const esportazione = await exportService.esportaDaModello(modello, filtro)
          const dati = esportazione.dati
          if (dati.length > 0 || _.get(modello, 'file.creaFileVuoto')) {
            const result = await exportService.generaFile(modello, dati, document)
            if (verbose && result) {
              alert(result.status)
            }
          }
          if (modello.marcaTrasferiti) {
            await exportService.marcaTrasferiti(esportazione.tipo, codiceModello, esportazione.ids)
          }
        } catch(error) {
          console.log(error)
        }
      }        
/*       async onEsporta(codiceModello, idx) {
        const modello = this.modelli.find(x => x.codice === codiceModello)
        const filtro = this.filtro[idx]
        
        const { dati, tipo, ids } = await exportService.esportaDaModello(modello, filtro)
        const result = await exportService.generaFile(modello, dati, document)
        alert(result.status)
      } */
    }
  }
</script>
